import React from "react";
import "./NotFound.css";

export default () =>
  <div className="NotFound">
    <h3>These are not the droids your looking for...</h3>
  </div>;
